import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 26, className = "", once = true }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.15 }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <p
    className={`font-mono text-[11px] font-semibold uppercase tracking-[0.28em] ${
      light ? "text-brand-bright" : "text-brand"
    }`}
  >
    {children}
  </p>
);
